import React from 'react'
import { CFSelect, CFView } from 'components'
import Hero from './Hero'
import Promotions from './Promotions'
import About from './About'
import Gallery from './Gallery'
import Contact from './Contact'
import Footer from './Footer'
import WelcomeModal from './WelcomeModal'
import { dispatch } from 'store'
import { promotionsBg } from '../../images'

export default () => {
  return (
    <CFView row justifyCenter bg="black">
      <CFView maxWidth="1400px" w="100%">
        {/* <MobileScreen>
          <LocationSelect />
        </MobileScreen> */}
        {/* <Header /> */}
        <Hero />
        <CFView image={`url(${promotionsBg}) top/ cover no-repeat`} zIndex={90}>
          <Promotions />
          <About />
          <Gallery />
        </CFView>
        <Contact />
        <Footer />
      </CFView>
      <CFSelect selector={dispatch.restaurant.getWelcomeMessage}>
        <WelcomeModal />
      </CFSelect>
    </CFView>
  )
}
